import React from "react";
import ComparisonReport from "../comparison/ComparisonReport";
import AvgWeightGanttChart from "../dashboard/avgWeightGanttChart";
import { useTranslation } from 'react-i18next';

const AvgBirdWeightComparison = () => {
  const { t } = useTranslation(['common', 'analytics']);
  return (
  <ComparisonReport
    title={t('analytics:compare.avgWeightReport')}
    renderChart={(data) => (
      <AvgWeightGanttChart
        data={data}
        title={t('analytics:compare.ganttTitle')}
      />
    )}
  />
  );
};

export default AvgBirdWeightComparison;
